import { createElementBlock as t, openBlock as e, createElementVNode as o } from "vue";
import h from "./index289.js";
const l = {}, r = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 60 60"
};
function m(n, a, s, c, p, L) {
  return e(), t("svg", r, a[0] || (a[0] = [
    o("path", { d: "M43.5 15.75a1.25 1.25 0 0 1 .128 2.494l-.128.006h-27a1.25 1.25 0 0 1-.128-2.494l.128-.006h27ZM21 31.5a1.25 1.25 0 0 1 .128 2.494L21 34h-4.5a1.25 1.25 0 0 1-.128-2.494l.128-.006H21Zm22.5 0a1.25 1.25 0 0 1 .128 2.494L43.5 34H27a1.25 1.25 0 0 1-.128-2.494L27 31.5h16.5Zm-12 5.5a1.25 1.25 0 0 1 .128 2.494l-.128.006h-15a1.25 1.25 0 0 1-.128-2.494L16.5 37h15Zm12 0a1.25 1.25 0 0 1 .128 2.494l-.128.006h-6a1.25 1.25 0 0 1-.128-2.494L37.5 37h6ZM21 20.5a1.25 1.25 0 0 1 .128 2.494L21 23h-4.5a1.25 1.25 0 0 1-.128-2.494l.128-.006H21Zm22.5 0a1.25 1.25 0 0 1 .128 2.494L43.5 23H27a1.25 1.25 0 0 1-.128-2.494L27 20.5h16.5Zm-12 5.5a1.25 1.25 0 0 1 .128 2.494l-.128.006h-15a1.25 1.25 0 0 1-.128-2.494L16.5 26h15Zm12 15.75a1.25 1.25 0 0 1 .128 2.494l-.128.006h-27a1.25 1.25 0 0 1-.128-2.494l.128-.006h27Zm0-15.75a1.25 1.25 0 0 1 .128 2.494l-.128.006h-6a1.25 1.25 0 0 1-.128-2.494L37.5 26h6Z" }, null, -1)
  ]));
}
const i = /* @__PURE__ */ h(l, [["render", m]]);
export {
  i as default
};
